<div
  class="text-white bg-[#003869] rounded-lg font-poppins font-semibold lg:flex
  lg:justify-evenly lg:items-center w-3/4 m-auto p-12 my-20">
  <div class="text-4xl lg:text-6xl">7 dias</div>
  <div class="lg:w-2/3">
    <h2 class="text-3xl mb-4">Experimente agora!</h2>
    <span>
      O RISCO é TODO MEU. Em até 7 DIAS depois do pagamento, você pode cancelar
      por qualquer motivo, e devolvemos todo o valor pago.
    </span>
  </div>
</div>
